const e = "Compte", t = "Solde du compte", n = "Description du compte", a = "ID de compte", r = "Additions", o = "Ajustements", s = "Montant", i = "et", u = "Postuler", c = "Précédent", l = "Compte de solde", d = "ID de compte de solde", p = "Réservé", m = "Capturé", f = "Catégorie", v = "Impayés", g = "Fermer", y = "Contactez l'assistance", b = "Contactez l'assistance pour obtenir de l'aide.", h = "Contactez l'assistance pour obtenir de l'aide et partagez le code d'erreur %{requestId}", T = "Copié", R = "Copier", A = "Corrections", C = "Devise", F = "Date", P = "Plage de dates", N = "Description", S = "Ignorer", D = "Télécharger", z = "Téléchargement en cours", L = "E-mail", x = "L'entité n'a pas été trouvée", I = "Transaction introuvable pour le titulaire du compte spécifié", O = "Frais", q = "Fichier", M = "Barre de filtre", V = "De", w = "Total", j = "Fonds capturés", B = "Retour", W = "Subvention accordée", k = "Remboursements de subventions", E = "Masquer le contenu", U = "ID", Y = "Champ incomplet", H = "En cours", _ = "Chargement", G = "max", X = "min.", J = "Mobile", Q = "Reversement net", K = "Reversements suivants", Z = "Pas de données", $ = "Aucun chiffre négatif n'est autorisé", ee = "Aucun reversement trouvé", te = "Aucun rapport trouvé", ne = "Aucune transaction trouvée", ae = "Autre", re = "Navigation paginée", oe = "Partiel", se = "ID de paiement", ie = "Mode de paiement", ue = "Informations pour le reversement", ce = "Les informations sur les reversements sont générées tous les jours à minuit, heure UTC.", le = "Reversements", de = "En attente", pe = "Veuillez revenir plus tard.", me = "Veuillez contacter l'assistance pour obtenir de l'aide.", fe = "Contacter l'assistance", ve = "ID de référence", ge = "Actualiser", ye = "Remboursements", be = "Remboursement de la transaction", he = "Nous n'avons pas pu traiter le remboursement. Réessayez plus tard.", Te = "Une erreur s'est produite.", Re = "Votre client recevra l'argent dans un délai maximal de 40 jours. Lorsque le remboursement aura été effectué, vous verrez une nouvelle transaction de remboursement dans votre liste.", Ae = "Remboursement envoyé !", Ce = "Montant à rembourser", Fe = "Les remboursements peuvent prendre jusqu'à 40 jours selon le mode de paiement. Les frais sont inclus.", Pe = "Rembourser %{amount}", Ne = "Motif du remboursement", Se = "Référence", De = "Montant restant", ze = "Rapport", Le = "Les rapports sont générés tous les jours à minuit, heure UTC.", xe = "rapports", Ie = "Réinitialiser", Oe = "Inverse", qe = "Une erreur s'est produite.", Me = "Un problème est survenu. Réessayez en actualisant la page ou retentez plus tard.", Ve = "Statut", we = "Liste structurée", je = "Soustractions", Be = "Somme des reversements le même jour", We = "Onglets", ke = "Le code d'erreur est %{requestId}", Ee = "Il n'y a pas de résultats", Ue = "Dans la demande, des champs obligatoires sont manquants ou des données ne sont pas valides.", Ye = "Une erreur inattendue s'est produite", He = "Le compte de solde sélectionné est incorrect", _e = "Fuseau horaire", Ge = "À", Xe = "Total entrant", Je = "Total sortant", Qe = "La valeur de À doit être égale ou supérieure à la valeur de De", Ke = "Détails de la transaction", Ze = "Transactions", $e = "Aperçu des transactions", et = "Type de transaction", tt = "Transferts", nt = "Essayez une autre recherche ou réinitialisez vos filtres, et nous réessayerons.", at = "Réessayez en actualisant la page ou retentez plus tard.", rt = "Montant", ot = "Type", st = "Valeur", it = "Nous n'avons pas pu charger l'aperçu des reversements.", ut = "Nous n'avons pas pu charger l'aperçu des rapports.", ct = "Nous n'avons pas pu charger l'aperçu des transactions.", lt = "Nous n'avons pas pu charger vos comptes de solde.", dt = "Nous n'avons pas pu charger vos reversements.", pt = "Nous n'avons pas pu charger vos rapports.", mt = "Nous n'avons pas pu charger vos transactions.", ft = {
  account: e,
  accountBalance: t,
  accountDescription: n,
  accountID: a,
  additions: r,
  adjustments: o,
  amount: s,
  and: i,
  apply: u,
  back: c,
  balanceAccount: l,
  balanceAccountId: d,
  Booked: p,
  "button.clearAll": "Tout effacer",
  "calendar.controls": "Commandes de navigation dans le calendrier",
  "calendar.nextMonth": "Mois suivant",
  "calendar.previousMonth": "Mois précédent",
  "calendar.timezone": "Le fuseau horaire est défini sur : GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Votre compte est inactif",
  "capital.actionNeeded": "Action requise",
  "capital.bankAccountDetails": "Informations sur le compte bancaire",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "Numéro de compte",
  "capital.bankCountryOrRegion": "Pays/région",
  "capital.bankRoutingNumber": "Numéro de routage",
  "capital.bankSortCode": "Code guichet",
  "capital.businessFinancing": "Financement d'entreprise",
  "capital.businessFinancingOffer": "Offre de financement d'entreprise",
  "capital.businessFinancingSummary": "Résumé du financement d'entreprise",
  "capital.closed": "Fermé",
  "capital.couldNotContinueWithTheOffer": "Nous n'avons pas pu continuer avec l'offre.",
  "capital.couldNotLoadFinancialOffers": "Nous n'avons pas pu charger les offres financières.",
  "capital.dailyRepaymentRate": "Taux de remboursement journalier",
  "capital.daysAndDaysLeft": "%{days} jours (%{daysLeft} jours restants)",
  "capital.expectedRepaymentPeriod": "Période de remboursement prévue",
  "capital.failed": "Échec",
  "capital.fees": "Frais",
  "capital.fullyRepaid": "Entièrement remboursé",
  "capital.goToTermsAndConditions": "Accéder aux conditions générales",
  "capital.grantID": "ID de la subvention",
  "capital.howMuchMoneyDoYouNeed": "De combien d'argent avez-vous besoin ?",
  "capital.inProgress": "En cours",
  "capital.legalSubtitleAU": "Adyen Capital est fourni par Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "Les prêts sont émis par Adyen N.V.",
  "capital.legalSubtitleGB": "Les prêts sont émis par Adyen N.V. représentée par sa succursale de Londres.",
  "capital.legalSubtitleUS": "Les prêts sont émis par la succursale de San Francisco d'Adyen N.V. et sont soumis à l'approbation du crédit.",
  "capital.maximumRepaymentPeriod": "Période de remboursement maximale",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Remboursement minimum tous les %{days} jours pour rembourser le financement à temps",
  "capital.needSomeExtraMoney": "Besoin d'argent supplémentaire ?",
  "capital.offerLegalNoticeDescriptionUS": "Si votre demande de crédit commercial est refusée, vous avez le droit d'obtenir une déclaration écrite des raisons spécifiques du refus. Pour obtenir cette déclaration, veuillez contacter Adyen Credit Support Team en envoyant un e-mail à %{email} dans les 60 jours suivant la date à laquelle vous êtes informé de notre décision. Nous vous enverrons une déclaration écrite des raisons du refus dans les 30 jours suivant la réception de votre demande. %{break} Aux États-Unis, la Federal Equal Credit Opportunity Act interdit aux créanciers de discriminer les demandeurs de crédit sur la base de la race, de la couleur de peau, de la religion, de la nationalité, du sexe, de l'état matrimonial, de l'âge (à condition que le demandeur ait la capacité juridique de conclure un contrat contraignant), parce que tout ou partie du revenu du demandeur provient d'un programme d'aide publique, ou parce que le demandeur a exercé de bonne foi un droit en vertu de la Consumer Credit Protection Act. L'agence fédérale qui contrôle la conformité à cette loi concernant ce créancier est l'Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219, États-Unis.",
  "capital.offerLegalNoticeTitleUS": "Créancier : Adyen N.V. – Succursale de San Francisco %{break} 505 Brannan Street, San Francisco, CA 94107, États-Unis.",
  "capital.oneMonth": "1 mois",
  "capital.pending": "En attente",
  "capital.primaryAccount": "Compte principal",
  "capital.remaining": "Restant",
  "capital.remainingAmount": "Montant restant",
  "capital.remainingFees": "Frais restants",
  "capital.repaid": "Remboursé",
  "capital.repaidAmount": "Montant remboursé",
  "capital.repaidFees": "Frais remboursés",
  "capital.repaymentBalanceInfo": "Il vous reste actuellement %{amount} à payer (frais inclus)",
  "capital.repaymentThreshold": "Seuil de remboursement",
  "capital.requestedFunds": "Fonds demandés",
  "capital.requestFunds": "Demander des fonds",
  "capital.requesting": "Demande en cours",
  "capital.reviewOffer": "Évaluer l'offre",
  "capital.revoked": "Révoqué",
  "capital.seeNewOffer": "Voir la nouvelle offre",
  "capital.seeOptions": "Voir les options",
  "capital.sendRepayment": "Envoyer le remboursement",
  "capital.sendRepaymentNotice": "Il est possible que le virement bancaire correspondant au remboursement de votre prêt ne soit visible sur votre compte de prêt que 2 à 3 jours ouvrables après.",
  "capital.sendRepaymentSubtitle": "Transférez de l'argent sur ce compte bancaire pour rembourser une partie ou la totalité de votre prêt.",
  "capital.signTermsAndConditionsToReceiveFunds": "Signez les conditions générales pour recevoir les fonds.",
  "capital.signTheTermsToReceiveYourFunds": "Signez les conditions pour recevoir les fonds",
  "capital.termEnds": "Fin de la période : ",
  "capital.thereIsNoPrimaryAccountConfigured": "Aucun compte principal configuré",
  "capital.thisOfferExpiresOn": "Cette offre expire le %{date}.",
  "capital.totalFees": "Total des frais",
  "capital.totalRepaymentAmount": "Montant total du remboursement",
  "capital.unsupportedRegionDescription": "Le financement d'entreprise n'est pas encore disponible dans votre région, mais revenez ici plus tard pour une offre.",
  "capital.unsupportedRegionTitle": "Plus d'informations bientôt !",
  "capital.weCouldNotContinueWithTheOffer": "Nous n'avons pas pu continuer avec l'offre.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "Nous n'avons pas pu continuer avec l'offre. Contactez l'assistance pour obtenir de l'aide.",
  "capital.weCouldNotLoadFinancialOffers": "Nous n'avons pas pu charger les offres financières.",
  "capital.weCouldNotProcessThisRequestTryAgain": "Nous n'avons pas pu traiter cette demande. Réessayez avec une nouvelle offre.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "Nous avons reçu votre demande et nous l'examinons actuellement. Revenez plus tard pour connaître les étapes suivantes.",
  "capital.writtenOff": "Effacé",
  "capital.xDays": "%{days} jours",
  "capital.xMonths": "%{months} mois",
  "capital.xPercent": "%{percentage} %",
  "capital.youAcceptedButThenReturnedTheseFunds": "Vous avez accepté mais vous avez ensuite renvoyé ces fonds",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Vous avez accepté ces fonds, mais vous ne les avez pas remboursés",
  "capital.youAreRequestingFundingOf": "Vous demandez un financement de",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Vous avez été présélectionné pour un financement d'entreprise",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " jusqu'à %{amount}.",
  "capital.yourRequestedFundsWere": "Les fonds que vous avez demandés : ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Vous devriez recevoir les fonds dans un délai d'un jour ouvrable",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Vous devrez rembourser au minimum %{amount} tous les %{days} jours pour rembourser intégralement les fonds d'ici le %{date}.",
  "capital.youWillSoonQualifyForAFinancialOffer": "Vous serez bientôt éligible à une offre financière !",
  capture: m,
  category: f,
  chargeback: v,
  closeIconLabel: g,
  contactSupport: y,
  contactSupportForHelp: b,
  contactSupportForHelpAndShareErrorCode: h,
  copied: T,
  copy: R,
  correction: A,
  currency: C,
  date: F,
  dateRange: P,
  default: "Par défaut",
  description: N,
  dismiss: S,
  download: D,
  downloading: z,
  email: L,
  entityWasNotFound: x,
  entityWasNotFoundDetail: I,
  "error.pleaseTryAgainLater": "Veuillez réessayer plus tard.",
  "error.somethingWentWrongWithDownload": "Une erreur s'est produite pendant le téléchargement",
  "expandableCard.collapse": "Réduire",
  "expandableCard.expand": "Développer",
  export: "Exporter",
  fee: O,
  file: q,
  "filter.date.since": "Depuis le %{date}",
  "filter.date.until": "Jusqu'au %{date}",
  filterBar: M,
  "filterPlaceholder.category": "Type",
  "filterPlaceholder.currency": "Devise",
  "filterPlaceholder.status": "Statut",
  from: V,
  full: w,
  fundsCaptured: j,
  goBack: B,
  grantIssued: W,
  grantRepayment: k,
  hideContent: E,
  id: U,
  incompleteField: Y,
  inProgress: H,
  loading: _,
  max: G,
  min: X,
  mobile: J,
  netPayout: Q,
  nextPayouts: K,
  noData: Z,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: te,
  noTransactionsFound: ne,
  other: ae,
  paginatedNavigation: re,
  "pagination.nextPage": "Page suivante",
  "pagination.previousPage": "Page précédente",
  "pagination.showing": "Affichage",
  partial: oe,
  paymentId: se,
  paymentMethod: ie,
  payoutDetails: ue,
  payoutsNotice: ce,
  payoutsTitle: le,
  Pending: de,
  pleaseComeBackLater: pe,
  pleaseReachOutToSupportForAssistance: me,
  "rangePreset.custom": "Personnalisé",
  "rangePreset.last30Days": "30 derniers jours",
  "rangePreset.last7Days": "7 derniers jours",
  "rangePreset.lastMonth": "Mois dernier",
  "rangePreset.lastWeek": "La semaine dernière",
  "rangePreset.thisMonth": "Ce mois-ci",
  "rangePreset.thisWeek": "Cette semaine",
  "rangePreset.yearToDate": "Depuis le début de l'année",
  reachOutToSupport: fe,
  referenceID: ve,
  refresh: ge,
  refund: ye,
  "refund.amountAlreadyRefunded": "Vous avez déjà remboursé %{amount}",
  "refund.amountFailed": "Le remboursement de %{amount} a échoué. Il n'est pas possible de rembourser ce montant pour le moment. Veuillez contacter l'assistance.",
  "refund.amountInProgress": "Le remboursement partiel de %{amount} est en cours de traitement.",
  "refund.fee": "Fee (Frais)",
  "refund.fullAmountFailed": "Il n'est pas possible de rembourser cette transaction. Veuillez contacter l'assistance.",
  "refund.fullAmountRefunded": "Le montant total a été remboursé au client",
  "refund.goToPayment": "Accéder à la transaction",
  "refund.maximumRefundable": "Vous ne pouvez pas rembourser plus de %{amount}",
  "refund.onlyRefundable": "Vous ne pouvez rembourser que %{amount}",
  "refund.originalAmount": "Montant initial",
  "refund.originalPayment": "Transaction d'origine",
  "refund.paymentPspReference": "Référence PSP du paiement",
  "refund.pspReference": "Référence PSP",
  "refund.refundFee": "Frais de remboursement",
  "refund.refundPspReference": "Référence PSP du remboursement",
  "refund.returnToRefund": "Retour au remboursement",
  "refund.theRefundIsBeingProcessed": "Le remboursement est en cours de traitement.",
  refundAction: be,
  refundActionErrorSubtitle: he,
  refundActionErrorTitle: Te,
  refundActionSuccessSubtitle: Re,
  refundActionSuccessTitle: Ae,
  refundAmount: Ce,
  "refundAmount.excess": "Vous ne pouvez pas dépasser le montant disponible de %{amount}",
  "refundAmount.required": "Saisissez un montant de remboursement",
  "refunded.full": "Entièrement remboursé",
  "refunded.partial": "Partiellement remboursé",
  refundNotice: Fe,
  refundPayment: Pe,
  refundReason: Ne,
  "refundReason.duplicate": "Dupliquer",
  "refundReason.fraudulent": "Fraude",
  "refundReason.issue_with_item_sold": "Problème avec l'article vendu",
  "refundReason.other": "Autre",
  "refundReason.requested_by_customer": "Demandé par le client",
  refundReference: Se,
  "refundReference.placeholder": "Saisissez la référence ici",
  remainingAmount: De,
  report: ze,
  "reportsError.tooManyDownloads": "Nous n'avons pas pu télécharger tous les fichiers. Veuillez réessayer plus tard.",
  reportsNotice: Le,
  reportsTitle: xe,
  "reportType.payout": "Versement",
  reset: Ie,
  Reversed: Oe,
  "select.filter.placeholder": "Espace réservé",
  "select.noOptionsFound": "Aucune option ne correspond à cette recherche",
  somethingWentWrong: qe,
  somethingWentWrongTryRefreshingOrComeBackLater: Me,
  status: Ve,
  structuredList: we,
  subtractions: je,
  sumOfSameDayPayouts: Be,
  tabs: We,
  theErrorCodeIs: ke,
  thereAreNoResults: Ee,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: Ue,
  thereWasAnUnexpectedError: Ye,
  theSelectedBalanceAccountIsIncorrect: He,
  timezone: _e,
  to: Ge,
  "tooltip.ATM": "Argent retiré à un distributeur automatique",
  "tooltip.Capital": "Argent provenant d’un prêt ou d’un remboursement de prêt",
  "tooltip.Chargeback": "Argent remboursé à un client suite à une transaction contestée",
  "tooltip.Correction": "Ajustements à vos fonds, y compris les annulations de transactions et les corrections de dépôts",
  "tooltip.Fee": "Frais de transaction et frais liés au moyen de paiement",
  "tooltip.Other": "Transactions n’appartenant pas à une autre catégorie, généralement un ajustement",
  "tooltip.Payment": "Argent versé sur votre compte suite à une transaction de vente",
  "tooltip.Refund": "Argent renvoyé à un client suite à une transaction remboursée",
  "tooltip.totalIncoming": "Tout l'argent versé sur votre compte en fonction des filtres sélectionnés",
  "tooltip.totalOutgoing": "Tous les frais, remboursements, reversements et autres dépenses basés sur les filtres sélectionnés",
  "tooltip.Transfer": "Argent transféré de votre compte vers un autre compte",
  totalIncoming: Xe,
  totalOutgoing: Je,
  toValueShouldBeGreaterThanTheFromValue: Qe,
  transactionDetails: Ke,
  transactions: Ze,
  transactionsOverviewTitle: $e,
  transactionType: et,
  transfer: tt,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: nt,
  tryRefreshingThePageOrComeBackLater: at,
  txAmount: rt,
  "txType.ATM": "Distributeur automatique",
  "txType.Capital": "Capital",
  "txType.Chargeback": "Chargeback",
  "txType.Correction": "Correction",
  "txType.Fee": "Fee (Frais)",
  "txType.Other": "Autre",
  "txType.Payment": "Transaction",
  "txType.Refund": "Remboursement",
  "txType.Transfer": "Transfert",
  type: ot,
  value: st,
  weCouldNotLoadThePayoutsOverview: it,
  weCouldNotLoadTheReportsOverview: ut,
  weCouldNotLoadTheTransactionsOverview: ct,
  weCouldNotLoadYourBalanceAccounts: lt,
  weCouldNotLoadYourPayouts: dt,
  weCouldNotLoadYourReports: pt,
  weCouldNotLoadYourTransactions: mt
};
export {
  p as Booked,
  de as Pending,
  Oe as Reversed,
  e as account,
  t as accountBalance,
  n as accountDescription,
  a as accountID,
  r as additions,
  o as adjustments,
  s as amount,
  i as and,
  u as apply,
  c as back,
  l as balanceAccount,
  d as balanceAccountId,
  m as capture,
  f as category,
  v as chargeback,
  g as closeIconLabel,
  y as contactSupport,
  b as contactSupportForHelp,
  h as contactSupportForHelpAndShareErrorCode,
  T as copied,
  R as copy,
  A as correction,
  C as currency,
  F as date,
  P as dateRange,
  ft as default,
  N as description,
  S as dismiss,
  D as download,
  z as downloading,
  L as email,
  x as entityWasNotFound,
  I as entityWasNotFoundDetail,
  O as fee,
  q as file,
  M as filterBar,
  V as from,
  w as full,
  j as fundsCaptured,
  B as goBack,
  W as grantIssued,
  k as grantRepayment,
  E as hideContent,
  U as id,
  H as inProgress,
  Y as incompleteField,
  _ as loading,
  G as max,
  X as min,
  J as mobile,
  Q as netPayout,
  K as nextPayouts,
  Z as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  te as noReportsFound,
  ne as noTransactionsFound,
  ae as other,
  re as paginatedNavigation,
  oe as partial,
  se as paymentId,
  ie as paymentMethod,
  ue as payoutDetails,
  ce as payoutsNotice,
  le as payoutsTitle,
  pe as pleaseComeBackLater,
  me as pleaseReachOutToSupportForAssistance,
  fe as reachOutToSupport,
  ve as referenceID,
  ge as refresh,
  ye as refund,
  be as refundAction,
  he as refundActionErrorSubtitle,
  Te as refundActionErrorTitle,
  Re as refundActionSuccessSubtitle,
  Ae as refundActionSuccessTitle,
  Ce as refundAmount,
  Fe as refundNotice,
  Pe as refundPayment,
  Ne as refundReason,
  Se as refundReference,
  De as remainingAmount,
  ze as report,
  Le as reportsNotice,
  xe as reportsTitle,
  Ie as reset,
  qe as somethingWentWrong,
  Me as somethingWentWrongTryRefreshingOrComeBackLater,
  Ve as status,
  we as structuredList,
  je as subtractions,
  Be as sumOfSameDayPayouts,
  We as tabs,
  ke as theErrorCodeIs,
  Ue as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  He as theSelectedBalanceAccountIsIncorrect,
  Ee as thereAreNoResults,
  Ye as thereWasAnUnexpectedError,
  _e as timezone,
  Ge as to,
  Qe as toValueShouldBeGreaterThanTheFromValue,
  Xe as totalIncoming,
  Je as totalOutgoing,
  Ke as transactionDetails,
  et as transactionType,
  Ze as transactions,
  $e as transactionsOverviewTitle,
  tt as transfer,
  nt as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  at as tryRefreshingThePageOrComeBackLater,
  rt as txAmount,
  ot as type,
  st as value,
  it as weCouldNotLoadThePayoutsOverview,
  ut as weCouldNotLoadTheReportsOverview,
  ct as weCouldNotLoadTheTransactionsOverview,
  lt as weCouldNotLoadYourBalanceAccounts,
  dt as weCouldNotLoadYourPayouts,
  pt as weCouldNotLoadYourReports,
  mt as weCouldNotLoadYourTransactions
};
